import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DValorDominio } from '@dian/api-basicos-parametricas';
import { DDocumento } from '@dian/api-formulario';

@Component({
  selector: 'app-datos-declarante',
  templateUrl: './datos-declarante.component.html',
  styleUrls: ['./datos-declarante.component.css']
})
export class DatosDeclaranteComponent implements OnInit {

  @Input('model') modelo: DDocumento = new DDocumento();
  @Input('model2100') model2100: DDocumento = new DDocumento();
  @Input('generos') listaGenero: DValorDominio[] = [];
  @Input('actividadesEconomicas') listaActividadesEconomicasVigentes: any[];
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();

  isFirstTime: boolean = true;
  
  constructor() { }

  ngOnInit() {
    this.validateForm();
    this.isFirstTime = false;    
  }

  validateForm() {
    if (this.isFirstTime)
      if (this.modelo.doc.cuerpo.cs_id_286) {
        this.model2100.doc.cuerpo.cs_id_673 = this.modelo.doc.cuerpo.cs_id_286;
        }
      
    if (this.model2100.doc.cuerpo.cs_id_673 && this.model2100.doc.cuerpo.cs_id_673!="0" && this.modelo.doc.cuerpo.cs_id_24) 
      this.isCompleted.emit(true);
    this.saveModel.emit(true);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/datos-declarante/datos-declarante.component.ts